import { Box, SkeletonRectangle } from '@leagueplatform/genesis-core';
import {
  MasonryEngineNode,
  MasonryEngineNodeRendererProps,
} from '@leagueplatform/masonry-engine';
import React, { forwardRef } from 'react';
import { Props } from './types';

export const SmallSkeleton = forwardRef<HTMLDivElement, Props>((props, ref) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <Box aria-busy aria-live="polite" {...props} ref={ref}>
    <SkeletonRectangle
      height={{
        '@initial': '160px',
        '@mobile': '180px',
      }}
    />
  </Box>
));

export type SmallSkeletonWSNode = MasonryEngineNode<'loadingSmall', Props>;

export const SmallSkeletonWSRenderer = ({
  rootElementRef,
  ...props
}: MasonryEngineNodeRendererProps<SmallSkeletonWSNode>) => (
  // eslint-disable-next-line react/jsx-props-no-spreading
  <SmallSkeleton ref={rootElementRef} {...props} />
);
